import React, { useEffect, useState } from "react";
import { Questionnaire, QuestionnaireDefinition } from "../common/models";
import { QuestionnaireTaskView } from "../common/QuestionnaireTaskView";
import Typography from "@mui/material/Typography";
import SuicidalThoughtsAndBehaviorsView from "./SuicidalThoughtsAndBehaviorsView";

const Definition: QuestionnaireDefinition = {
  name: 'DSM-5 Adult',
  key: 'dsm5AdultQuestionnaire',
  title: 'DSM-5 Adult',
  description: '',
  cohort: 'mood',
  type: 'questionnaire',
  estimatedCompletionTime: '4:00',
  groups: [
    {
      key: 'dsm5Adult',
      // Note: We need to display multiple lines in the description.
      content: (
        <Typography>During the past TWO (2) WEEKS, how much (or how often) have you been bothered by the following problems?</Typography>
      ),
      questions: [
        {
          // The key is from REDCap.
          key: 'littleInterest',
          type: 'multiple-choice',
          question: 'Little interest or pleasure in doing things?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'feelingDown',
          type: 'multiple-choice',
          question: 'Feeling down, depressed, or hopeless?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'feelingMoreIrritated',
          type: 'multiple-choice',
          question: 'Feeling more irritated, grouchy, or angry than usual?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'sleepingLess',
          type: 'multiple-choice',
          question: 'Sleeping less than usual, but still have a lot of energy?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'startingMoreProjects',
          type: 'multiple-choice',
          question: 'Starting lots more projects than usual or doing more risky things than usual?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'feelingNervous',
          type: 'multiple-choice',
          question: 'Feeling nervous, anxious, frightened, worried, or on edge?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'feelingPanic',
          type: 'multiple-choice',
          question: 'Feeling panic or being frightened?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'avoidingSituations',
          type: 'multiple-choice',
          question: 'Avoiding situations that make you anxious?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'unexplainedAches',
          type: 'multiple-choice',
          question: 'Unexplained aches and pains (e.g., head, back, joints, abdomen, legs)?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'illnessNotTakenSerious',
          type: 'multiple-choice',
          question: 'Feeling that your illnesses are not being taken seriously enough?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'selfHarm',
          type: 'multiple-choice',
          question: 'Thoughts of actually hurting yourself?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'hearingThings',
          type: 'multiple-choice',
          question: `Hearing things other people couldn't hear, such as voices even when no one was around?`,
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'someoneHearThoughts',
          type: 'multiple-choice',
          question: 'Feeling that someone could hear your thoughts, or that you could hear what another person was thinking?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'sleepQuality',
          type: 'multiple-choice',
          question: 'Problems with sleep that affected your sleep quality over all?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'memoryIssues',
          type: 'multiple-choice',
          question: 'Problems with memory (e.g., learning new information) or with location (e.g., finding your way home)?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'unpleasantThoughts',
          type: 'multiple-choice',
          question: 'Unpleasant thoughts, urges, or images that repeatedly enter your mind?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'repeatActs',
          type: 'multiple-choice',
          question: 'Feeling driven to perform certain behaviors or mental acts over and over again?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'feelingDetached',
          type: 'multiple-choice',
          question: 'Feeling detached or distant from yourself, your body, your physical surroundings, or your memories?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'noPurpose',
          type: 'multiple-choice',
          question: 'Not knowing who you really are or what you want out of life?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'isolated',
          type: 'multiple-choice',
          question: 'Not feeling close to other people or enjoying your relationships with them?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'drinkingMore',
          type: 'multiple-choice',
          question: 'Drinking at least 4 drinks of any kind of alcohol in a single day?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'smokingMore',
          type: 'multiple-choice',
          question: 'Smoking any cigarettes, a cigar, or pipe, or using snuff or chewing tobacco?',
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'medicationUse',
          type: 'multiple-choice',
          question: `Using any of the following medicines ON YOUR OWN, that is, without a doctor's prescription, in greater amounts or longer than prescribed [e.g., painkillers (like Vicodin), stimulants (like Ritalin or Adderall), sedatives or tranquilizers (like sleeping pills or Valium), or drugs like marijuana, cocaine or crack, club drugs (like ecstasy), hallucinogens (like LSD), heroin, inhalants or solvents (like glue), or methamphetamine (like speed)]?`,
          options: [
            { key: '0', displayName: 'None (Not at all)' },
            { key: '1', displayName: 'Slight (Rare, less than a day or two)' },
            { key: '2', displayName: 'Mild (Several days)' },
            { key: '3', displayName: 'Moderate (More than half the days)' },
            { key: '4', displayName: 'Severe (Nearly every day)' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        }
      ],
    },
    {
      key: 'asrm',
      // Note: We need to display multiple lines in the description.
      content: (
          <>
            <Typography variant="h4" component='div'>(ASRM)</Typography>
            <Typography>Choose the one statement in each group that best describes the way you (the individual receiving care) have been feeling for the past week.</Typography>
            <Typography>
              <span>Please note:</span>
              <span>&nbsp;</span>
              The word “occasionally” when used here means once or twice; “often” means several times or more and “frequently” means most of the time.
            </Typography>
          </>
        ),
        condition: (questionnaire: Questionnaire) => {
          const group = questionnaire.groups.find(x => x.key === 'dsm5Adult');
          const sleepLessQuestion = group?.questions.find(x => x.key === 'sleepingLess');
          const startingMoreProjects = group?.questions.find(x => x.key === 'startingMoreProjects');
          const sleepLessQuestionValue = sleepLessQuestion?.value ? Number(sleepLessQuestion.value) : null;
          const startingMoreProjectsValue = startingMoreProjects?.value ? Number(startingMoreProjects.value) : null;
          return (sleepLessQuestionValue !== null && sleepLessQuestionValue >= 2) ||
            (startingMoreProjectsValue !== null && startingMoreProjectsValue >= 2);
        },
        questions: [
          {
          // The key is from REDCap.
            key: 'mania1',
            type: 'multiple-choice',
            question: 'Question 1',
            options: [
              { key: '1', displayName: 'I do not feel happier or more cheerful than usual.' },
              { key: '2', displayName: 'I occasionally feel happier or more cheerful than usual.' },
              { key: '3', displayName: 'I often feel happier or more cheerful than usual.' },
              { key: '4', displayName: 'I feel happier or more cheerful than usual most of the time.' },
              { key: '5', displayName: 'I feel happier or more cheerful than usual all of the time.' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'mania2',
            type: 'multiple-choice',
            question: 'Question 2',
            options: [
              { key: '1', displayName: 'I do not feel more self-confident than usual.' },
              { key: '2', displayName: 'I occasionally feel more self-confident than usual.' },
              { key: '3', displayName: 'I often feel more self-confident than usual.' },
              { key: '4', displayName: 'I frequently feel more self-confident than usual.' },
              { key: '5', displayName: 'I feel extremely self-confident all of the time.' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'mania3',
            type: 'multiple-choice',
            question: 'Question 3',
            options: [
              { key: '1', displayName: 'I do not need less sleep than usual.' },
              { key: '2', displayName: 'I occasionally need less sleep than usual.' },
              { key: '3', displayName: 'I often need less sleep than usual.' },
              { key: '4', displayName: 'I frequently need less sleep than usual.' },
              { key: '5', displayName: 'I can go all day and all night without any sleep and still not feel tired.' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'mania4',
            type: 'multiple-choice',
            question: 'Question 4',
            options: [
              { key: '1', displayName: 'I do not talk more than usual.' },
              { key: '2', displayName: 'I occasionally talk more than usual.' },
              { key: '3', displayName: 'I often talk more than usual.' },
              { key: '4', displayName: 'I frequently talk more than usual.' },
              { key: '5', displayName: 'I talk constantly and cannot be interrupted.' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'mania5',
            type: 'multiple-choice',
            question: 'Question 5',
            options: [
              { key: '1', displayName: 'I have not been more active (either socially, sexually, at work, home, or school) than usual.' },
              { key: '2', displayName: 'I have occasionally been more active than usual.' },
              { key: '3', displayName: 'I have often been more active than usual.' },
              { key: '4', displayName: 'I have frequently been more active than usual.' },
              { key: '5', displayName: 'I am constantly more active or on the go all the time.' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          }
      ]
    },
    {
      key: 'socialPhobia',
      content: (
        <>
          <Typography variant="h4"  component='div'>(Social Phobia)</Typography>
          <Typography>The following questions ask about thoughts, feelings, and behaviors that you may have had about social situations. Usual social situations include: public speaking, speaking in meetings, attending social events or parties, introducing yourself to others, having conversations, giving and receiving compliments, making requests of others, and eating and writing in public.</Typography>
          <br />
          <Typography>During the PAST 7 DAYS, I have...</Typography>
        </>
      ),
      condition: (questionnaire: Questionnaire) => {
        const group = questionnaire.groups.find(x => x.key === 'dsm5Adult');
        const feelingNervousQuestion = group?.questions.find(x => x.key === 'feelingNervous');
        const feelingPanicQuestion = group?.questions.find(x => x.key === 'feelingPanic');
        const avoidingSituationsQuestion = group?.questions.find(x => x.key === 'avoidingStuations');
        const feelingNervousQuestionValue = feelingNervousQuestion?.value ? Number(feelingNervousQuestion.value) : null;
        const feelingPanicQuestionValue = feelingPanicQuestion?.value ? Number(feelingPanicQuestion.value) : null;
        const avoidingSituationsQuestionValue = avoidingSituationsQuestion?.value ? Number(avoidingSituationsQuestion.value) : null;
        return (feelingNervousQuestionValue !== null && feelingNervousQuestionValue >= 2) ||
            (feelingPanicQuestionValue !== null && feelingPanicQuestionValue >= 2) ||
            (avoidingSituationsQuestionValue !== null && avoidingSituationsQuestionValue >= 2);
      },
      questions: [
          {
            // The key is from REDCap.
            key: 'socialPhobia1',
            type: 'multiple-choice',
            question: 'felt moments of sudden terror, fear, or fright in social situations',
            options: [
              { key: '0', displayName: 'Never' },
              { key: '1', displayName: 'Occasionally' },
              { key: '2', displayName: 'Half of the time' },
              { key: '3', displayName: 'Most of the time' },
              { key: '4', displayName: 'All of the time' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'socialPhobia2',
            type: 'multiple-choice',
            question: 'felt anxious, worried, or nervous about social situations',
            options: [
              { key: '0', displayName: 'Never' },
              { key: '1', displayName: 'Occasionally' },
              { key: '2', displayName: 'Half of the time' },
              { key: '3', displayName: 'Most of the time' },
              { key: '4', displayName: 'All of the time' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'socialPhobia3',
            type: 'multiple-choice',
            question: 'had thoughts of being rejected, humiliated, embarrassed, ridiculed, or offending others',
            options: [
              { key: '0', displayName: 'Never' },
              { key: '1', displayName: 'Occasionally' },
              { key: '2', displayName: 'Half of the time' },
              { key: '3', displayName: 'Most of the time' },
              { key: '4', displayName: 'All of the time' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'socialPhobia4',
            type: 'multiple-choice',
            question: 'felt a racing heart, sweaty, trouble breathing, faint, or shaky in social situations',
            options: [
              { key: '0', displayName: 'Never' },
              { key: '1', displayName: 'Occasionally' },
              { key: '2', displayName: 'Half of the time' },
              { key: '3', displayName: 'Most of the time' },
              { key: '4', displayName: 'All of the time' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'socialPhobia5',
            type: 'multiple-choice',
            question: 'felt tense muscles, felt on edge or restless, or had trouble relaxing in social situations',
            options: [
              { key: '0', displayName: 'Never' },
              { key: '1', displayName: 'Occasionally' },
              { key: '2', displayName: 'Half of the time' },
              { key: '3', displayName: 'Most of the time' },
              { key: '4', displayName: 'All of the time' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'socialPhobia6',
            type: 'multiple-choice',
            question: 'avoided, or did not approach or enter, social situations',
            options: [
              { key: '0', displayName: 'Never' },
              { key: '1', displayName: 'Occasionally' },
              { key: '2', displayName: 'Half of the time' },
              { key: '3', displayName: 'Most of the time' },
              { key: '4', displayName: 'All of the time' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'socialPhobia7',
            type: 'multiple-choice',
            question: 'left social situations early or participated only minimally (e.g., said little, avoided eye contact)',
            options: [
              { key: '0', displayName: 'Never' },
              { key: '1', displayName: 'Occasionally' },
              { key: '2', displayName: 'Half of the time' },
              { key: '3', displayName: 'Most of the time' },
              { key: '4', displayName: 'All of the time' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'socialPhobia8',
            type: 'multiple-choice',
            question: 'spent a lot of time preparing what to say or how to act in social situations',
            options: [
              { key: '0', displayName: 'Never' },
              { key: '1', displayName: 'Occasionally' },
              { key: '2', displayName: 'Half of the time' },
              { key: '3', displayName: 'Most of the time' },
              { key: '4', displayName: 'All of the time' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'socialPhobia9',
            type: 'multiple-choice',
            question: 'distracted myself to avoid thinking about social situations',
            options: [
              { key: '0', displayName: 'Never' },
              { key: '1', displayName: 'Occasionally' },
              { key: '2', displayName: 'Half of the time' },
              { key: '3', displayName: 'Most of the time' },
              { key: '4', displayName: 'All of the time' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          },
          {
            // The key is from REDCap.
            key: 'socialPhobia10',
            type: 'multiple-choice',
            question: 'needed help to cope with social situations (e.g., alcohol or medications, superstitious objects)',
            options: [
              { key: '0', displayName: 'Never' },
              { key: '1', displayName: 'Occasionally' },
              { key: '2', displayName: 'Half of the time' },
              { key: '3', displayName: 'Most of the time' },
              { key: '4', displayName: 'All of the time' }
            ],
            value:  '',
            defaultValue: '',
            required: true
          }
      ]
    }
  ]
};
export const DSM5AdultDefinition = Definition;

export const DSM5Adult = ({onCompletion}: {onCompletion: () => void}) => {
  const [questionnaire, setQuestionnaire] = useState<Questionnaire>(() => ({
    id: 'dsm5AdultQuestionnaires',
    ...Definition,
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'in-progress',
  }));

  const [selfHarmValue, setSelfHarmValue] = useState<string | Date | string[] | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    if (selfHarmValue !== null && Number(selfHarmValue) > 0) {
      setDialogOpen(true);
    }
  }, [selfHarmValue]);

  console.log('DSM5Adult component rendered', questionnaire);

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleOnCompletion = () => {
    console.log('DSM5Adult completed');

    onCompletion();
  };

  const handleOnChange = (questionnaire: Questionnaire) => {
    console.log('questionnaire', questionnaire);

    const selfHarmQuestion = questionnaire.groups
    .find(group => group.key === 'dsm5Adult')?.questions
    .find(question => question.key === 'selfHarm');

    if (selfHarmQuestion) {
      setSelfHarmValue(selfHarmQuestion.value);
    }

    setQuestionnaire(questionnaire);
  }

  console.log('DSM5Adult component rendered', questionnaire);

  return (
    <div>
      <QuestionnaireTaskView questionnaire={questionnaire} onChange={handleOnChange} onCompletion={handleOnCompletion  } />
      <SuicidalThoughtsAndBehaviorsView open={dialogOpen} onClose={handleDialogClose} />
    </div>
  );
}
